import plur from 'plur'
import {memo, useCallback} from 'react'

import {openDialog} from '../../../../actions'
import {DialogType, stringifyId} from '../../../../types'
import type {TestOccurrenceId} from '../../../../types'
import IconButton from '../../../common/IconButton/IconButton'

import TestMetadataPopup from './TestMetadataPopup/TestMetadataPopup.container'

import {useAppDispatch} from 'src/hooks/react-redux'

type Props = {
  className?: string
  testOccurrenceId?: TestOccurrenceId
  metadataCount: number
}

function TestMetadataIcon({className, testOccurrenceId, metadataCount}: Props) {
  const dispatch = useAppDispatch()
  const toggleTestMetadataDialog = useCallback(
    () => dispatch(openDialog(stringifyId(testOccurrenceId), DialogType.METADATA_DETAIL_POPUP)),
    [dispatch, testOccurrenceId],
  )
  return metadataCount > 0 ? (
    <>
      <IconButton
        className={className}
        icon="attachment"
        title={`The test has ${metadataCount} metadata ${plur('attachment', metadataCount)}`}
        onClick={toggleTestMetadataDialog}
      />
      <TestMetadataPopup testOccurrenceId={testOccurrenceId} />
    </>
  ) : null
}

export default memo(TestMetadataIcon)
